// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","wrapper":"App_wrapper__RCHjb"};